import React from 'react'
import { Link } from 'react-scroll'
import './style.css'

const ClosingStatement = () => {
    return (
        <section className="closing-statement-section">
            <div className="container">
                <div className="closing-statement-inner">
                    <p className="closing-statement-text">
                        Every student deserves access to global opportunities.
                        Every entrepreneur deserves access to the right mentorship.
                        Every university deserves access to the right students.
                    </p>
                    <h2 className="closing-statement-headline">Let's build that future together.</h2>
                    <Link
                        activeClass="active"
                        to="contact"
                        spy={true}
                        smooth={true}
                        duration={500}
                        offset={-95}
                        className="theme-btn"
                    >
                        Connect with Asslam Shaikh
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default ClosingStatement
